'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var errCode = require('err-code');

var updateTree = require('./utils/update-tree');

var updateMfsRoot = require('./utils/update-mfs-root');

var toSources = require('./utils/to-sources');

var removeLink = require('./utils/remove-link');

var toMfsPath = require('./utils/to-mfs-path');

var toTrail = require('./utils/to-trail');

var applyDefaultOptions = require('./utils/apply-default-options');

var _require = require('../../utils'),
    withTimeoutOption = _require.withTimeoutOption;

var defaultOptions = {
  recursive: false,
  cidVersion: 0,
  hashAlg: 'sha2-256',
  flush: true
};

module.exports = function (context) {
  return withTimeoutOption( /*#__PURE__*/function () {
    var _mfsRm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var args,
          _yield$toSources,
          sources,
          options,
          _iterator,
          _step,
          source,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              args = Array.from(_args);
              _context.next = 3;
              return toSources(context, args, defaultOptions);

            case 3:
              _yield$toSources = _context.sent;
              sources = _yield$toSources.sources;
              options = applyDefaultOptions(args, defaultOptions);

              if (sources.length) {
                _context.next = 8;
                break;
              }

              throw errCode(new Error('Please supply at least one path to remove'), 'ERR_INVALID_PARAMS');

            case 8:
              sources.forEach(function (source) {
                if (source.path === '/') {
                  throw errCode(new Error('Cannot delete root'), 'ERR_INVALID_PARAMS');
                }
              });
              _iterator = _createForOfIteratorHelper(sources);
              _context.prev = 10;

              _iterator.s();

            case 12:
              if ((_step = _iterator.n()).done) {
                _context.next = 18;
                break;
              }

              source = _step.value;
              _context.next = 16;
              return removePath(context, source.path, options);

            case 16:
              _context.next = 12;
              break;

            case 18:
              _context.next = 23;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](10);

              _iterator.e(_context.t0);

            case 23:
              _context.prev = 23;

              _iterator.f();

              return _context.finish(23);

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[10, 20, 23, 26]]);
    }));

    function mfsRm() {
      return _mfsRm.apply(this, arguments);
    }

    return mfsRm;
  }());
};

var removePath = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context, path, options) {
    var mfsPath, trail, child, parent, _yield$removeLink, cid, newRootCid;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return toMfsPath(context, path);

          case 2:
            mfsPath = _context2.sent;
            _context2.next = 5;
            return toTrail(context, mfsPath.mfsPath, options);

          case 5:
            trail = _context2.sent;
            child = trail.pop();
            parent = trail[trail.length - 1];

            if (parent) {
              _context2.next = 10;
              break;
            }

            throw errCode(new Error("".concat(path, " does not exist")), 'ERR_NOT_FOUND');

          case 10:
            if (!(child.type === 'directory' && !options.recursive)) {
              _context2.next = 12;
              break;
            }

            throw errCode(new Error("".concat(path, " is a directory, use -r to remove directories")), 'ERR_WAS_DIR');

          case 12:
            _context2.next = 14;
            return removeLink(context, {
              parentCid: parent.cid,
              name: child.name,
              hashAlg: options.hashAlg,
              cidVersion: options.cidVersion,
              flush: options.flush
            });

          case 14:
            _yield$removeLink = _context2.sent;
            cid = _yield$removeLink.cid;
            parent.cid = cid; // update the tree with the new child

            _context2.next = 19;
            return updateTree(context, trail, options);

          case 19:
            newRootCid = _context2.sent;
            _context2.next = 22;
            return updateMfsRoot(context, newRootCid);

          case 22:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function removePath(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();